import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { PostProjectParams } from './service';

export enum PostProjectActions {
  Failure = '[Project PostProject] Failure',
  Request = '[Project PostProject] Request',
  Success = '[Project PostProject] Success',
  Reset = '[Project PostProject] Reset',
}

export const PostProjectFailure = createAction(PostProjectActions.Failure, props<{ error: HttpErrorResponse }>());

export const PostProjectRequest = createAction(
  PostProjectActions.Request,
  props<{ body: HomeProject; parameters?: PostProjectParams }>()
);

export const PostProjectSuccess = createAction(PostProjectActions.Success, props<{ data: HomeProject }>());

export const PostProjectReset = createAction(PostProjectActions.Reset);
